"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CfgCssClassListRu = /** @class */ (function () {
    function CfgCssClassListRu() {
    }
    CfgCssClassListRu.getLangData = function () {
        return {
            document_title: "Стили",
            editor: {
                breadcrumb: {
                    new_css_class: ["Создание CSS класса"],
                    edit_css_class: ["Редактирование CSS класса"]
                },
                message: {
                    css_class_added: "Css класс добавлен!",
                    css_class_changed: "Css класс изменен!"
                },
                error: {
                    field_class_name_empty: "Поле [имя css класса] не заполнено!",
                    field_class_type_empty: "Поле [тип css класса] не выбрано!",
                },
                title: {
                    new_css_class: "Добавить Css класс",
                    edit_css_class: "Изменить Css класс",
                },
                fields: {
                    class_name: {
                        caption: "Название класса:",
                        placeholder: "Введите название класса",
                    },
                    class_type: {
                        caption: "Тип класса:",
                        placeholder: "Выберите тип класса",
                    }
                },
                checkboxes: {
                    deprecated: "Класс устарел"
                },
                buttons: {
                    save: "Сохранить",
                    create: "Создать",
                    back: "Вернуться",
                }
            },
            list: {
                message: {
                    set_as_actual_fmt: "Css класс {0} помечен как актуальный",
                    set_as_deprecated_fmt: "Css класс {0} помечен как устаревший",
                    css_class_deleted_fmt: "Css класс {0} был успешно удален",
                    css_class_loaded: "Css классы загружены с сервера !"
                },
                rows: {
                    class_name: "Имя класса",
                    class_type: "Тип класса",
                    is_actual: {
                        title: "Актуальный",
                        menu: {
                            actual: {
                                menu: "Пометить как актуальный",
                                text: "Да"
                            },
                            deprecate: {
                                menu: "Пометить как устаревший",
                                text: "Нет"
                            }
                        },
                        filter: {
                            actual: "Актуальный",
                            deprecate: "Устаревший",
                        }
                    },
                    date_added: "Добавлен",
                    date_changed: "Изменен",
                    action: {
                        title: "Действия",
                        edit: "Изменить",
                        delete: {
                            hint: "Удалить",
                            confirm: "Удалить эту запись ?",
                        }
                    }
                },
                toolbars: {
                    hints: {
                        create: "Создать",
                        refresh: "Обновить",
                    }
                },
                footer: {
                    title_fmt: "Отображается на странице : {0} записей",
                },
                details: {
                    created: "Создан:",
                    changed: "Изменен:",
                }
            }
        };
    };
    return CfgCssClassListRu;
}());
exports.CfgCssClassListRu = CfgCssClassListRu;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cfg_css_class/ui/lang/CfgCssClassListRu.ts
// module id = 2362
// module chunks = 0